<section class="container pia-authenticationBlock">
  <div class="row">
    <div class="small-12 medium-8 columns pia-authenticationBlock-logo">
      <div>
        <img src="assets/images/pia-auth-logo.png" alt="Logo PIA" />
        <div>
          <h1 [innerHTML]="'authentication.title' | translate"></h1>
          <div>{{ "header.logo_subtitle" | translate }}</div>
        </div>
      </div>
      <div>
        <h2 [innerHTML]="'authentication.subtitle1' | translate"></h2>
        <p>{{ "authentication.subtitle2" | translate }}</p>
      </div>
    </div>
    <div class="small-12 medium-4 columns">
      <div class="pia-authenticationBlock-auth">
        @if (authService.state) {
        <div>
          <div>
            @switch (stepForm) {
            <!-- Initial block / Sign in -->
            @case ('logIn') {
            <app-sign-in
              [fromSignUp]="fromValidation"
              (validated)="onSubmited()"
              (canceled)="changeDisplay('checkUuid')"
              (forget)="changeDisplay('forgetPassword')"
            ></app-sign-in>
            }
            <!-- New account - Activation code -->
            @case ('checkUuid') {
            <app-uuid
              (canceled)="changeDisplay('logIn')"
              (validated)="changeDisplay('signUp'); accountData = $event"
            ></app-uuid>
            }
            <!-- New account - Define password -->
            @case ('signUp') {
            <app-password
              (validated)="changeDisplay('logIn'); fromValidation = $event"
              (canceled)="changeDisplay('checkUuid')"
              [accountData]="accountData"
            ></app-password>
            }
            <!-- Account recovery - Email -->
            @case ('forgetPassword') {
            <app-forget-password
              (canceled)="changeDisplay('logIn')"
              (validated)="changeDisplay('resetPassword')"
            ></app-forget-password>
            }
            <!-- Account recovery - Reset code -->
            @case ('resetPassword') {
            <app-uuid
              [reset]="true"
              (canceled)="changeDisplay('forgetPassword')"
              (validated)="changeDisplay('newPassword'); accountData = $event"
            ></app-uuid>
            }
            <!-- Account recovery - New password -->
            @case ('newPassword') {
            <app-password
              [reset]="true"
              (canceled)="changeDisplay('resetPassword')"
              (validated)="changeDisplay('logIn'); fromValidation = $event"
              [accountData]="accountData"
            ></app-password>
            } }
          </div>
        </div>
        } @else {
        <div class="pia-authenticationBlock-enter">
          <div>{{ "authentication.start_app" | translate }}</div>
          <p
            class="pia-authenticationBlock-warning"
            [innerHTML]="'authentication.description' | translate"
          ></p>
          <a routerLink="/entries" class="btn btn-green">{{
            "authentication.start" | translate
          }}</a>
        </div>
        }
      </div>
    </div>
  </div>
</section>
<app-dialog></app-dialog>
